const SETTINGS = {
  DEBUG: false,
  HOST: '',
  API_HOST: '',
  AMAZON_PAY_SELLER_ID: '',
  AMAZON_PAY_V2_STORE_ID: '',
  AMAZON_PAY_V2_PUBLIC_KEY_ID: '',
  ANCESTRY_CLIENT_ID: '',
  ANCESTRY_REDIRECT_URI: '',
  FACEBOOK_APP_ID: '',
  STRIPE_API_KEY: '',
  COOKIE_ACCESS_TOKEN_NAME: '',
  COOKIE_ACCESS_TOKEN_OPTIONS: {},
  USER_AGENT: '',
  CLIENT_ID: '',
  VERSION: '',
  MYCANVAS_CLASSIC_API_URL: '',
};

export default SETTINGS;
